import { LogbookDataForAllSubmissionsQuery } from '__generated__/graphql';
import { differenceInSeconds } from 'date-fns';

export const REVIEW_MINUTES_PER_CASE = 15;

export const calcHoursBetween = (startTime: Date, endTime: Date) => differenceInSeconds(endTime, startTime) / 60 / 60;

interface Cat1CalcInput {
    startTime?: string;
    endTime?: string;
}

export const calcTotalCat1Hours = (studySubmissions: Cat1CalcInput[]) => {
    const hrs =
        studySubmissions?.map((ss) => {
            if (!ss.startTime || !ss.endTime) {
                return 15 / 60;
            }

            const diffInSeconds = Math.abs(differenceInSeconds(toDate(ss.endTime), toDate(ss.startTime)));
            return atLeastFifteenMinutesInSeconds(diffInSeconds) / 60 / 60;
        }) ?? [];

    return hrs.reduce((acc, cur) => acc + cur, 0);
};

export const atLeastFifteenMinutesInSeconds = (seconds: number) => {
    const abs = Math.abs(seconds); // why are we taking the absolute value?

    if (abs >= 15 * 60) {
        return abs;
    }

    return 15 * 60;
};

interface Cat2CalcInput {
    reviewSecondsSpent?: number | null | undefined;
}

export const calcTotalCat2Hours = (studySubmissions: Cat2CalcInput[]) =>
    studySubmissions
        ?.map((sub) => atLeastFifteenMinutesInSeconds(sub.reviewSecondsSpent ?? 0) / 60 / 60)
        .reduce((acc, cur) => acc + cur, 0);

export const toDate = (date: number | string) => {
    if (typeof date === 'number') {
        return new Date(date);
    }

    const dateAsNumber = Number(date);
    if (Number.isNaN(dateAsNumber)) {
        return new Date(date);
    }

    return new Date(dateAsNumber);
};
